export default "/fonts/vendor/katex/dist/KaTeX_Caligraphic-Regular.woff2?d6484fce1ef428d5bd94a903d7973395";